import classNames from "classnames";
import { DetailedHTMLProps, FC, TextareaHTMLAttributes } from "react";
import styles from "./TextArea.module.scss";

interface TextAreaProps
  extends Omit<
    DetailedHTMLProps<
      TextareaHTMLAttributes<HTMLTextAreaElement>,
      HTMLTextAreaElement
    >,
    "prefix"
  > {
  label?: string;
  error?: string | false;
  required?: boolean;
  textAreaClassName?: string;
}

const TextArea: FC<TextAreaProps> = ({
  label,
  className,
  error,
  required,
  textAreaClassName,
  placeholder = "Enter text...",
  ...rest
}) => {
  return (
    <div className={classNames(styles.textarea_container, className)}>
      {label && (
        <label
          className={classNames(styles.input_label, {
            [styles.required]: required,
          })}
        >
          {label}
        </label>
      )}
      <textarea
        className={classNames(styles.textarea, textAreaClassName, {
          [styles.has_error]: !!error,
        })}
        placeholder={placeholder}
        {...rest}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default TextArea;
